/*
 * Purpose: Live runs indicator in AppShell header — links to dashboard
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useExecutionRuntimeStore } from '@/stores/executionRuntimeStore';
import { REMEDIATION } from '@/lib/remediationRoutes';

export function LiveRunsPill() {
  const count = useExecutionRuntimeStore((s) => s.running.length);

  if (count === 0) return null;

  return (
    <Button
      asChild
      size="sm"
      variant="outline"
      className="h-8 gap-1.5 border-[hsl(var(--ab-green-core)/0.4)] bg-[hsl(var(--ab-green-core)/0.08)] text-[hsl(var(--ab-green-deep))] dark:text-[hsl(var(--ab-green-glow))]"
    >
      <Link to={REMEDIATION.dashboard}>
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[hsl(var(--ab-green-glow))] opacity-70" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[hsl(var(--ab-green-core))]" />
        </span>
        <Activity className="h-3.5 w-3.5" />
        <span className="text-xs font-medium tabular-nums">{count} live</span>
      </Link>
    </Button>
  );
}
